"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "relative",
    width: "100%",
    tableLayout: "fixed",
    padding: props => {
      return theme.spacing(props.padding);
    },
    fontFamily: "Akkurat, sans-serif",
    "& tr + tr": {
      borderTop: "1px solid",
      borderColor: theme.palette.divider
    },
    "& thead th": {
      position: "sticky",
      zIndex: 2,
      backgroundColor: "inherit",
      top: 0
    },
    "& th": {
      textAlign: "left"
    }
  }
}));

const LayoutTable = ({
  spacing = 1,
  padding = 0,
  children
}) => {
  const classes = useStyles({
    padding
  });
  return _react.default.createElement("table", {
    className: classes.root,
    container: true,
    "data-spacing": spacing,
    "data-layout": "table"
  }, children);
};

var _default = LayoutTable;
exports.default = _default;
module.exports = exports.default;